import { updateObject } from "../../shared/utility";
import { storeConstants, globalConstants } from "../../constants";

//-------InitialState of the reducer
const initialState = {
  stores: [],
  currentStore: "",
  storeOwners: [],
  editStore: {},
  userNotifications: [],
  payouts: {},
};

//-------Export Authentication Reducer
export const store = (state = initialState, action) => {
  switch (action.type) {
    //-------get stores
    case storeConstants.GET_STORES + globalConstants.SUCCESS:
      return updateObject(state, {
        stores: action.data,
      });
    // Add store reducer
    case storeConstants.ADD_STORE + globalConstants.SUCCESS:
      return updateObject(state, {
        stores: action.data,
      });
    case storeConstants.GET_STORE_OWNERS + globalConstants.SUCCESS:
      return updateObject(state, {
        storeOwners: action.data,
      });
    case storeConstants.SET_CURRENT_STORE + globalConstants.SUCCESS:
      return updateObject(state, {
        currentStore: action.data,
      });
    case storeConstants.GET_USER_NOTIFICATIONS + globalConstants.SUCCESS:
      return updateObject(state, {
        userNotifications: action.data,
      });
    case storeConstants.CREATE_NOTIFICATION + globalConstants.SUCCESS:
      return updateObject(state, {
        userNotifications: [action.data, ...state.userNotifications],
      });
    case storeConstants.PAYOUT_INFORMATION + globalConstants.SUCCESS:
      return updateObject(state, {
        payouts: action.data,
      });
    // refetch store configurations (Update reducers of discounts, margins, markups etc)
    case storeConstants.REFETCH_STORE_CONFIGURATIONS + globalConstants.SUCCESS:
      return updateObject(state, {
        currentStore: { ...state.currentStore },
      });
    case storeConstants.UPDATE_AUDIT_SESSION_COMPLETE + globalConstants.SUCCESS:
      if (action.data.id === state.currentStore.id) {
        return updateObject(state, {
          currentStore: {
            ...state.currentStore,
            isUpdatingInventoryAfterAudit: true,
          },
        });
      }
      return updateObject(state);
    case storeConstants.UPDATE_AUDIT_SESSION_COMPLETE_FALSE +
      globalConstants.SUCCESS:
      if (action.data === state.currentStore.id) {
        return updateObject(state, {
          currentStore: {
            ...state.currentStore,
            isUpdatingInventoryAfterAudit: false,
          },
        });
      }
      return updateObject(state);
    //-------Default State
    default:
      return state;
  }
};
